import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import moment from 'moment';
import util from '@/utils/util';

var WorkOrderListPage = function (_super) {
  __extends(WorkOrderListPage, _super);

  function WorkOrderListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.workOrderStatusList = [];
    _this.workOrderTypeList = [];
    _this.warehouseList = [];
    _this.loadingStatus = false;
    _this.lastParams = {};
    _this.searchData = _this.initFormData();
    _this.data = [];
    _this.total = _this.data.length;
    _this.columns = [];
    _this.rowSelection = {};
    _this.selectedList = [];
    _this.warehouseName = [{
      label: $t("\u6FB3\u6D32\u4ED3"),
      value: '1'
    }, {
      label: $t("\u6377\u514B\u4ED3"),
      value: '2'
    }, {
      label: $t("\u7F8E\u56FD\u4ED3"),
      value: '3'
    }];
    return _this;
  }

  Object.defineProperty(WorkOrderListPage.prototype, "id", {
    get: function get() {
      return this.$route.query.id;
    },
    enumerable: false,
    configurable: true
  });

  WorkOrderListPage.prototype.updateSearchList = function () {
    this.queryList();
  };

  WorkOrderListPage.prototype.initFormData = function () {
    return {
      code_field: 'workorder_code',
      code_value: '',
      warehouse_code: undefined,
      status: undefined,
      order_type: undefined,
      time_field: 'created_at',
      time_range: util.getDefaultTimeCondition(),
      page_index: 1,
      page_size: 10
    };
  };

  WorkOrderListPage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData.page_index = 1;
            return [4, this.queryList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  WorkOrderListPage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData = this.initFormData();
            return [4, this.queryList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  WorkOrderListPage.prototype.handleEdit = function (data) {
    this.$router.push({
      name: 'EditWorkorderPage',
      query: {
        id: data.id,
        type: 'edit'
      },
      params: {
        noCache: '1'
      }
    });
  };

  WorkOrderListPage.prototype.handleCopy = function (data) {
    this.$router.push({
      name: 'CopyWorkorderPage',
      query: {
        id: data.id,
        type: 'copy'
      },
      params: {
        noCache: '1'
      }
    });
  };

  WorkOrderListPage.prototype.handleAbandon = function (ticketCode) {
    var _this = this;

    this.$confirm({
      title: this.t('废弃提示'),
      content: this.t('请确认是否废弃该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                return [4, this.$api.caseTicket.cancelWorkOrder({
                  ticket_code: ticketCode
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryList();
                } else {
                  this.$message.error(message);
                }

                return [2];
            }
          });
        });
      }
    });
  };

  WorkOrderListPage.prototype.handlePageChange = function (index, size) {
    this.searchData.page_index = index;
    this.searchData.page_size = size;
    this.queryList();
  };

  WorkOrderListPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData.workorder_id_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData.workorder_id_list = this.selectedList;
            }

            return [4, this.$api.caseTicket.exportWorkOrder(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;
            this.$util.exportExcel(data);
            return [2];
        }
      });
    });
  };

  WorkOrderListPage.prototype.queryList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var postData, _i, _a, key, res;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.rowSelection.selectedRowKeys = this.selectedList = [];
            postData = {};

            for (_i = 0, _a = Object.keys(this.searchData); _i < _a.length; _i++) {
              key = _a[_i];

              if (key === 'time_range') {
                if (this.searchData[key].length) {
                  postData.time_from = this.$util.formatDateTime(this.searchData[key][0]);
                  postData.time_to = this.$util.formatDateTime(this.searchData[key][1]);
                } else {
                  postData.time_from = undefined;
                  postData.time_to = undefined;
                }
              } else {
                postData[key] = this.searchData[key];
              }
            }

            this.lastParams = JSON.parse(JSON.stringify(postData));
            return [4, this.$api.caseTicket.queryList(postData)];

          case 1:
            res = _b.sent();

            if (res.code === 0) {
              this.data = res.data.data;
              this.total = res.data.total;
            }

            return [2];
        }
      });
    });
  };

  WorkOrderListPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryWarehouseOtherList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  WorkOrderListPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('工单号'),
      dataIndex: 'workorder_code',
      scopedSlots: {
        customRender: 'code'
      }
    }, {
      title: this.t('关联单号'),
      scopedSlots: {
        customRender: 'relation_order_code'
      }
    }, {
      title: this.t('仓库'),
      scopedSlots: {
        customRender: 'warehouse_desc'
      }
    }, {
      title: this.t('主题'),
      scopedSlots: {
        customRender: 'titleContent'
      }
    }, {
      title: this.t('工单状态'),
      dataIndex: 'status_text',
      filterEmpty: true
    }, {
      title: this.t('工单类型'),
      dataIndex: 'order_type_text',
      filterEmpty: true
    }, {
      title: this.t('创建人'),
      dataIndex: 'created_customer_name',
      filterEmpty: true
    }, {
      title: this.t('时间'),
      scopedSlots: {
        customRender: 'rangTime'
      },
      dataIndex: 'created_at'
    }, {
      title: this.t('操作'),
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
      }
    };
    var orderType = this.$route.query.type;

    if (this.$route.query.type) {
      this.searchData.order_type = Number(orderType);
    }

    if (this.$route.query.from) {
      this.searchData.time_field = 'created_at';
      this.searchData.time_range = [moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')];
    }

    this.queryList();
    this.queryWarehouseList();
  };

  __decorate([enumData('Assistant/CaseTicketStatusEnum')], WorkOrderListPage.prototype, "workOrderStatusList", void 0);

  __decorate([enumData('Assistant/CaseTicketOrderTypeEnum')], WorkOrderListPage.prototype, "workOrderTypeList", void 0);

  __decorate([userPrefPageSize('caseTicketList')], WorkOrderListPage.prototype, "initFormData", null);

  __decorate([loading('loadingStatus')], WorkOrderListPage.prototype, "queryList", null);

  WorkOrderListPage = __decorate([Component], WorkOrderListPage);
  return WorkOrderListPage;
}(Vue);

export default WorkOrderListPage;